import React, { Component } from 'react';
import request from '../../lib/requester';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import Autocomplete from '../../component/autocomplete';
import Select from 'react-select'

// Component
import GeneralInfo from '../../component/generalinfo';
import CustomerInfo from '../../component/customerinfo';
import ProductList from '../../component/productlist';
import Attachments from '../../component/attachments';
import Reason from '../../component/reason';
import ClaimInfo from '../../component/claiminfo';

class Detail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			claimNumber: '',
			branchId: '',
			branchCode: '',
			customerId: '',
			principalLetterNo: '',
			lovSupplierSite: [],
			lovSupplier: [],
			supplier: '',
			supplierId: 0,
			supplierSite: 0,
			orgInitital: '',
			orgId: '',
			reason: '',
			bankName: '',
			accOwner: '',
			paymentMethod: '',
			norek: '',
			npwp: '',
			skb: 'N',
			taxNo: '',
			taxDate: new Date(),
			fileSKB: { filename: '', path: '' },
			fileLain: { filename: '', path: '' },
			fileTambahan: { filename: '', path: '' },
			principalName: '',
			description: '',
			refNumber: '',
			programType: '',
			customerName: '',
			potongTagihan: '',
			pphRate: 1,
			pphType: '',
			dpp: 0,
			ppn: 0,
			pph: 0,
			totalAmount: 0,
			docs: [],
			fileContainer: [],
			error: [],
			listInvoice: [],
			lovPPH: [],
			success: '',
			user: JSON.parse(window.localStorage.getItem('is_user')) || {},
			submitteddate: '',
			skpnumber: '',
			programNumber: '',
			budgetType: '',
			program_budget: 0,
			assign_budget: 0,
			sales_target: 0,
			claimnumber: '',
			kwitansi: '',
			header_npwp: '',
			header_npwp_name: '',
			header_npwp_address: '',
			productList: [],
			fileRequired: {},
			docsContainer: [],
			h_name: '',
			h_npwp: '',
			h_address: '',
			general_claim_number: '',
			general_skp_number: '',
			general_program_number: '',
			general_principal: '',
			general_reff_number: '',
			general_program_type: '',
			general_description: '',
			general_program_submitted_date: '',
			general_program_start_date: '',
			general_program_end_date: '',
			general_claim_exp_date: '',
			general_budget_type: '',
			general_budget: '',
			general_budget_assigned: '',
			general_sales_target: '',
			general_customer_pph_type: '',
			general_customer_pph_rate: '',
			customer_name: '',
			customer_npwp_no: '',
			customer_npwp_address: '',
			customer_npwp_name: '',
			account: '',
			costCenter: '000',
			lovCC: [],
			lovAcc: [],
			lovSubacc: []
		};
	}

	componentDidMount = () => {
		this.getDetailProgram();
		this.getPPhType();
	};

	getPPhType = () => {
		let url = '/api/traces/v1/general/pph-type';
		request.getTraces(url, {
			success: function (response) {
				this.setState({ lovPPH: response.data.data });
			}.bind(this),
			error: function (e) {
				console.log(e);
			},
		});
	};

	renderLovPPh = () => {
		return (
			<select
				disabled
				className='form-control'
				name='pphType'
				value={this.state.pphType}
				onChange={this.handleChangeInput.bind(this)}>
				<option>- Select Type -</option>
				{this.state.lovPPH.map((item, index) => (
					<option value={item.pph_type} key={index}>
						{item.pph_type}
					</option>
				))}
			</select>
		);
	};

	getNpwp = () => {
		let url = '/api/orafin/v1/general/npwp-customer';
		let param = {
			customerid: this.state.customerId,
			branchId: this.state.branchId,
		};
		this.setState({ loading: true });
		request.postOracle(url, param, {
			success: function (response) {
				let { data } = response.data;

				this.setCustomerInfo(data);
				this.setState({
					npwp: data.npwp,
					header_npwp: data.npwp,
					header_npwp_name: data.name,
					header_npwp_address: data.address,
					loading: false,
				});
			}.bind(this),
			error: function (e) {
				this.setState({ loading: false });
			}.bind(this),
		});
	};

	getDetailProgram = () => {
		let url = '/api/traces/v1/claim/detail-by-claimid';
		let { id } = this.props.match.params;
		let param = {
			claim_id: id,
		};
		this.setState({ loading: true });
		request.postTraces(url, param, {
			success: function (response) {
				let { header, claim, attachment, invoice, product, document, npwp } =
					response.data.data;

				if (claim.doc_mandatory_filename) {
					attachment.push({
						document_name: '',
						path: claim.doc_mandatory_path || '',
						filename: claim.doc_mandatory_filename || '',
					});
				}
				if (claim.doc_tambahan_filename) {
					attachment.push({
						document_name: 'Additional Document',
						path: claim.doc_tambahan_path || '',
						filename: claim.doc_tambahan_filename || '',
					});
					document.push({
						document_name: 'Additional Document',
						path: claim.doc_tambahan_path || '',
						filename: claim.doc_tambahan_filename || '',
					});
				}
				let newDocs = document;
				let newAttach = attachment;

				// product
				product.map((item, index) => {
					item.item_costcenter = ''
					item.item_account = ''
					item.item_subaccount = ''
					return item
				})

				// set to component
				this.setGeneralInfo(header);

				this.setState({
					account: header.account,
					kwitansi: header.kwitansi,
					skpnumber: header.skp_number,
					claimnumber: header.claim_number,
					programNumber: header.program_number,
					budgetType: header.budget_type,
					sisabudget: header.sisa_budget,
					program_budget: header.program_budget,
					assign_budget: header.assign_budget,
					sales_target: header.sales_target,
					claimNumber: header.claim_number,
					branchId: header.branch_id,
					branchCode: header.branch_code,
					customerId: header.customer_id,
					principalLetterNo: claim.principal_letter_no,
					supplier: claim.aam_vendor_name,
					supplierId: claim.aam_vendor_id,
					supplierSite: claim.aam_vendor_site_id,
					loading: false,
					orgId: header.org_id,
					orgInitital: header.org_initial,
					bankName: claim.bank,
					accOwner: claim.bank_acc_owner,
					principalName: header.org_name,
					refNumber: header.ref_number,
					programType: header.program_name,
					description: header.description,
					customerName: header.customer_name || '',
					customer_name: header.customer_name,
					cust_receipt_no: header.cust_receipt_no,
					dpp: this.thousandSeparator(claim.dpp || 0),
					ppn: this.thousandSeparator(claim.ppn || 0),
					pph: this.thousandSeparator(claim.pph || 0),
					pphRate: claim.pph_rate,
					pphType: claim.pph_type,
					potongTagihan: claim.potong_tagihan,
					docs: newAttach,
					docsContainer: newDocs,
					listInvoice: invoice,
					submitteddate: moment(header.creation_date).format('DD-MMM-YYYY'),
					claimExpDate: moment(header.claim_exp_date).format('DD-MMM-YYYY'),
					startDate: moment(header.start_date).format('DD-MMM-YYYY'),
					endDate: moment(header.end_date).format('DD-MMM-YYYY'),
					paymentMethod: claim.payment_method,
					npwp: claim.npwp,
					norek: claim.no_rekening,
					skb: claim.skb,
					taxNo: claim.tax_no,
					taxDate: moment(claim.tax_date).format('DD-MMM-YYYY'),
					fileSKB: {
						filename: claim.doc_skb_filename,
						path: claim.doc_skb_path,
					},
					fileLain: {
						filename: claim.doc_lain_filename,
						path: claim.doc_lain_path,
					},
					fileTambahan: {
						filename: claim.doc_tambahan_filename,
						path: claim.doc_tambahan_path,
					},
					fileRequired: {
						filename: claim.doc_mandatory_filename,
						path: claim.doc_mandatory_path,
					},
					productList: product,
					header_npwp: npwp ? npwp.NPWP_NUMBER : '',
					header_npwp_name: npwp ? npwp.NPWP_NAME : '',
					header_npwp_address: npwp ? npwp.NPWP_ADDRESS : '',
				});
				this.getSupplierSite(claim.aam_vendor_id);
				// this.getNpwp();
				let app = this;
				window.setTimeout(() => {
					app.calculateAmount();
					console.log(app.state);
				}, 200);
			}.bind(this),
			error: function (e) {
				console.log(e);
				this.setState({ loading: false });
			}.bind(this),
		});
	};

	setGeneralInfo = (header) => {
		this.setState({
			general_claim_number: header.claim_number,
			general_skp_number: header.skp_number,
			general_program_number: header.program_number,
			general_principal: header.org_name,
			general_reff_number: header.ref_number,
			general_program_type: header.program_name,
			general_description: header.description,
			general_program_submitted_date: moment(header.creation_date).format(
				'DD-MMM-YYYY'
			),
			general_program_start_date: moment(header.start_date).format(
				'DD-MMM-YYYY'
			),
			general_program_end_date: moment(header.end_date).format('DD-MMM-YYYY'),
			general_claim_exp_date: moment(header.claim_exp_date).format(
				'DD-MMM-YYYY'
			),
			general_budget_type: header.budget_type,
			general_budget: header.program_budget,
			general_budget_assigned: header.assign_budget,
			general_sales_target: header.sales_target,
			general_customer_pph_type: header.pph_type,
			general_customer_pph_rate: header.pph_rate,
		});
	};

	setCustomerInfo = (customer) => {
		this.setState({
			customer_npwp_name: customer.name,
			customer_npwp_address: customer.address,
			customer_npwp_no: customer.npwp,
		});
	};

	showError = () => {
		if (this.state.error.length > 0) {
			return (
				<div className='alert alert-danger' role='alert'>
					<ul>
						{this.state.error.map((item, index) => {
							return <li key={index}>{item}</li>;
						})}
					</ul>
				</div>
			);
		}
	};

	showSuccess = () => {
		if (this.state.success.length > 0) {
			return (
				<div className='alert alert-success' role='alert'>
					<i className='fas fa-check'></i> {this.state.success}
				</div>
			);
		}
	};

	thousandSeparator = (value) => {
		value = value.toString();
		value = value.replace(/,/g, '').replace(/[^0-9.]/g, '');
		var parts = value.toString().split('.');
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		return parts.join('.');
	};

	removeSeparator = (value) => {
		value = value.toString();
		return value.replace(/,/g, '');
	};

	calculateAmount = () => {
		let { dpp, ppn, pph, totalAmount } = this.state;
		totalAmount =
			(parseInt(this.removeSeparator(dpp)) || 0) +
			(parseInt(this.removeSeparator(ppn)) || 0) -
			(parseInt(this.removeSeparator(pph)) || 0);
		let app = this;
		window.setTimeout(() => {
			totalAmount = Math.round(totalAmount);
			app.setState({
				totalAmount: this.thousandSeparator(totalAmount),
				ppn: this.thousandSeparator(ppn),
			});
		}, 500);
	};

	handleChangeInput = (event) => {
		let value = event.target.value;
		let name = event.target.name;

		if (name === 'pph' || name === 'ppn' || name === 'dpp') {
			value = this.thousandSeparator(value);
		}

		this.setState({ [name]: value });
		if (name === 'pph' || name === 'ppn' || name === 'dpp') {
			let app = this;
			window.setTimeout(() => {
				app.calculateAmount();
				app.forceUpdate();
			}, 100);
		}
	};

	renderDocument = () => {
		return this.state.docsContainer.map((item, index) => (
			<div className='row'>
				<div className='col-md-12'>
					<i className='fa fa-check text-success' />
					&nbsp;{item.document_name}
				</div>
			</div>
		));
	};

	renderLink = () => {
		return this.state.docs.map((item, index) => (
			<div className='col-md-12'>
				<i className='fa fa-file-pdf text-danger' />
				&nbsp;{' '}
				<Link to={{ pathname: item.path }} target='_blank'>
					{item.filename}
				</Link>
			</div>
		));
	};
	// renderDocument = () => {
	//   return this.state.docs.map((item, index) => (
	//     <div className="row border-bottom" key={index}>
	//       <div className="col-md-2 mt-2">{item.document_name}</div>
	//       <div className="col-md-6 mt-2">
	//         <Link to={{ pathname: item.path }} target="_blank">
	//           {item.filename}
	//         </Link>
	//       </div>
	//     </div>
	//   ));
	// };

	handleUpload = (e) => {
		if (e.target.files.length === 0) {
			return false;
		}

		let files = e.target.files[0];
		let { programDocId, index } = e.target.dataset;
		// validation
		let filename = files.name;
		var fileExt = filename.split('.').pop();
		var allowedFile = [
			'jpg',
			'png',
			'jpeg',
			'gif',
			'doc',
			'docx',
			'xls',
			'xlsx',
			'csv',
			'pdf',
		];
		if (allowedFile.indexOf(fileExt) < 0) {
			this.setState({ error: ['File extension not allowed'] });
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			return false;
		}

		const data = new FormData();
		data.append('myFile', files, files.name);
		this.setState({ loading: true });
		request.postnobody('/api/arman/v1/program/upload-file', data, {
			success: function (response) {
				let { data } = response.data;
				let container = this.state.fileContainer;
				data.program_doc_id = programDocId;
				data.index = index;
				container.push(data);
				this.setState({ fileContainer: container, loading: false });
				this.forceUpdate();
			}.bind(this),
			error: function (e) {
				this.setState({ loading: false });
			},
		});
	};

	renderUploadedFile = (index) => {
		let { fileContainer } = this.state;
		let find = _.find(fileContainer, function (o) {
			return parseInt(o.index) === parseInt(index);
		});
		if (find) {
			return (
				<span>
					<Link to={{ pathname: find.path }} target='_blank'>
						{find.filename}{' '}
					</Link>
					&nbsp;
					<button
						type='button'
						className='btn btn-danger'
						data-index={index}
						onClick={() => {
							this.removeFile(index);
						}}>
						<i className='fas fa-trash-alt'></i>
					</button>
				</span>
			);
		}
	};

	removeFile = (index) => {
		let indexing = _.findIndex(this.state.fileContainer, function (o) {
			return parseInt(o.index) === parseInt(index);
		});
		if (indexing >= 0) {
			let container = this.state.fileContainer;
			container.splice(indexing, 1);
			this.setState(container);
		}
	};

	validateForm = () => {
		let { potongTagihan, pphRate, pphType, dpp, ppn, fileContainer, docs } =
			this.state;
		let error = [];
		if (potongTagihan === '' || potongTagihan.length === 0) {
			error.push('Potong tagihan belum dipilih');
		}
		if (pphRate === 0 || pphRate.length === 0) {
			error.push('PPh Rate belum diinput');
		}
		if (pphType === '') {
			error.push('PPh Type belum dipilih');
		}
		if (parseInt(dpp) === 0 || dpp.length === 0) {
			error.push('DPP belum diinput');
		}
		if (parseInt(ppn) === 0 || ppn.length === 0) {
			error.push('PPn belum diinput');
		}
		if (fileContainer.length < docs.length) {
			error.push('Lampiran dokumen belum lengkap');
		}

		if (error.length > 0) {
			window.scrollTo(0, 0);
			this.setState({ error: error });
			return false;
		} else {
			return true;
		}
	};

	renderTableInvoice = () => {
		if (this.state.paymentMethod === 'INV') {
			return (
				<table className='table table-striped table-sm table-bordered'>
					<thead>
						<tr>
							<th>Invoice Number</th>
							<th>Invoice Amount</th>
							<th>Invoice Date</th>
						</tr>
					</thead>
					<tbody>
						{this.state.listInvoice.map((item, index) => (
							<tr key='index'>
								<td>{item.invoice_number}</td>
								<td className='text-right'>
									{this.thousandSeparator(item.invoice_amount)}
								</td>
								<td>
									{moment(new Date(item.invoice_date)).format('DD-MMM-YYYY')}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			);
		}
	};

	renderNorek = () => {
		if (this.state.paymentMethod === 'TRF') {
			// if (this.state.orgInitial === 'AAM') {
			if (1 === 1) {
				return (
					<div>
						<div className='form-group row'>
							<label htmlFor='inputEmail3' className='col-sm-4 col-form-label'>
								Supplier
							</label>
							<div className='col-sm-8'>
								<Autocomplete
									onchange={this.onChangeAutocomplete.bind(this)}
									isDisabled={true}
									currentvalue={this.state.supplier}
									currentIndex={0}
									principalCode={this.state.user.orgInitial}
									onselect={this.onSelectSupplier.bind(this)}
								/>
							</div>
						</div>
						<div className='form-group row'>
							<label htmlFor='inputEmail3' className='col-sm-4 col-form-label'>
								Supplier Site
							</label>
							<div className='col-sm-8'>
								<select
									className='form-control'
									disabled
									value={this.state.supplierSite}
									name='supplierSite'
									onChange={this.handleChangeInput.bind(this)}>
									<option value=''>- Select Supplier Site -</option>
									{this.state.lovSupplierSite.map((item, index) => (
										<option value={item.SUPPLIER_SITE_ID}>
											{item.SUPPLIER_SITE_CODE}
										</option>
									))}
								</select>
							</div>
						</div>
					</div>
				);
			} else {
				return (
					<div>
						<div className='form-group row'>
							<label htmlFor='inputEmail3' className='col-sm-4 col-form-label'>
								Account No
							</label>
							<div className='col-sm-8'>
								<input
									type='text'
									disabled
									autoComplete='off'
									className='form-control'
									id='inputEmail3'
									name='norek'
									placeholder='No Rekening'
									onChange={this.handleChangeInput.bind(this)}
									value={this.state.norek}
								/>
							</div>
						</div>
						<div className='form-group row'>
							<label htmlFor='inputEmail3' className='col-sm-4 col-form-label'>
								Bank Name
							</label>
							<div className='col-sm-8'>
								<input
									type='text'
									disabled
									autoComplete='off'
									className='form-control'
									id='inputEmail3'
									name='bankName'
									placeholder='No Rekening'
									onChange={this.handleChangeInput.bind(this)}
									value={this.state.bankName}
								/>
							</div>
						</div>
						<div className='form-group row'>
							<label htmlFor='inputEmail3' className='col-sm-4 col-form-label'>
								Account Owner
							</label>
							<div className='col-sm-8'>
								<input
									type='text'
									disabled
									autoComplete='off'
									className='form-control'
									id='inputEmail3'
									name='accOwner'
									placeholder='No Rekening'
									onChange={this.handleChangeInput.bind(this)}
									value={this.state.accOwner}
								/>
							</div>
						</div>
					</div>
				);
			}
		}
	};

	renderProduct = () => {
		// console.log(this.state.productList)
		return this.state.productList.map((item, index) => (
			<div className='row mb-2' key={index}>
				<div className='col-sm-4'>
					<input
						disabled
						type='text'
						className='form-control'
						name='productname'
						value={item.item_description}
					/>
				</div>
				<div className='col-sm-2'>
					<input
						disabled
						type='text'
						className='form-control'
						name='itemReff'
						value={item.item_reff}
					/>
				</div>
				<div className='col-sm-2'>
					<input
						disabled
						type='text'
						className='form-control'
						name='itemBudget'
						// value={item.item_budget}
						value={
							item.item_budget
								? item.item_budget.toLocaleString('en-US', {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								})
								: 0
						}
					/>
				</div>
				<div className='col-sm-2'>
					<input
						type='text'
						disabled
						className='form-control'
						name='itemActual'
						currentIndex={index}
						value={
							item.actual
								? item.actual.toLocaleString('en-US', {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								})
								: 0
						}
						placeholder='actual'
					/>
				</div>
			</div>
		));
	};

	renderTax = () => {
		let { ppn } = this.state;
		if (parseInt(this.removeSeparator(ppn)) > 0) {
			return (
				<div>
					<div className='form-group row'>
						<label htmlFor='inputEmail3' className='col-sm-4 col-form-label'>
							Tax No
						</label>
						<div className='col-sm-8'>
							<input
								type='text'
								disabled
								autoComplete='off'
								className='form-control'
								id='inputEmail3'
								name='taxNo'
								placeholder='Tax No'
								onChange={this.handleChangeInput.bind(this)}
								value={this.state.taxNo}
							/>
						</div>
					</div>
					<div className='form-group row'>
						<label htmlFor='inputEmail3' className='col-sm-4 col-form-label'>
							Tax Date
						</label>
						<div className='col-sm-8'>
							<input
								type='text'
								disabled
								className='form-control'
								value={this.state.taxDate}
							/>
						</div>
					</div>
				</div>
			);
		}
	};

	handleRedirect = (e) => {
		e.preventDefault()
		const url = request.getFileS3('skb', this.state.fileContainer.filename);
		if (url && url.length > 0) {
			window.open(url, '_blank');
		}
	};

	renderSKBAttachment = () => {
		if (this.state.skb === 'Y') {
			return (
				// <a

				<a
					href="#"
					onClick={this.handleRedirect.bind(this)}
					target="blank"
					rel="noopener noreferrer"
				>
					{this.state.fileSKB.filename}
				</a>
			);
		}
	};

	handleApprove = () => {
		let url = '/api/traces/v1/claim/update-principal';
		let { id } = this.props.match.params;
		let param = {
			claim_id: id,
			status: 'A',
			reason: '',
			source: 'infostep',
			menu: 'claim',
			function: 'approval claim dxm',
			user_id: this.state.user.user_id,
			user_name: this.state.user.username,
			lines: this.state.productList || []
		};
		request.postTraces(url, param, {
			success: function (response) {
				this.setState({ loading: false, success: 'Claim has been approved' });
				window.scrollTo(0, 0);
				let app = this;
				window.setTimeout(() => {
					app.props.history.push('/admin/claim/approval-dxm');
				}, 2000);
			}.bind(this),
			error: function (e) {
				console.log(e);
				this.setState({ loading: false });
			}.bind(this),
		});
	};

	handleFinance = () => {
		let url = '/finance/comet-AP/v1/create-invoice-w-attribute';

		let Products = this.state.productList
		let Error = []
		Products.forEach((item, index) => {
			if (item.item_costcenter.length === 0) {
				Error.push('Please select cost center for product: ' + item.item_description)
			}
			if (item.item_account.length === 0) {
				Error.push('Please select account for product: ' + item.item_description)
			}
			if (item.item_subaccount.length === 0) {
				Error.push('Please select subaccount for product: ' + item.item_description)
			}
		})

		if (Error.length > 0) {
			this.setState({ error: Error })
			window.scrollTo(0, 0)
			return false
		}

		let param = {
			header: {
				invoiceNum: this.state.claimNumber,
				invoiceDate: moment().format('DD-MMM-YYYY').toString(),
				invoiceType: 'STANDARD',
				invoiceAmount: parseInt(this.removeSeparator(this.state.totalAmount)),
				invoiceRcvDate: moment().format('DD-MMM-YYYY').toString(),
				vendorId: 18,
				vendorSiteId: 59691,
				description: this.state.claimNumber,
				glDate: moment().format('DD-MMM-YYYY').toString(),
				orgId: '82',
				source: 'TRACES',
				payGroupLookUpCode: 'KSR-02',
				paymentCode: 'CHECK',
			},
			line: this.getProductList(),
		};

		request.postFinance(url, param, {
			success: function (response) {
				this.handleApprove()
			}.bind(this),
			error: function (e) {
				console.log(e);
				this.setState({ loading: false });
			}.bind(this),
		});
	};

	getProductList = () => {
		const retVal = this.state.productList.map((obj) => {
			let account = this.state.account;
			let costCenter = this.state.costCenter;
			if (obj.item_description.toUpperCase().startsWith('OXYV')) {
				account = '51406';
			} else if (obj.item_description.toUpperCase().startsWith('STAR')) {
				account = '51202';
			}
			return {
				amount: parseInt(this.removeSeparator(obj.item_actual)),
				description: obj.item_description,
				taxClassificationCode: '',
				inventoryItemId: '',
				qtyInvoice: 1,
				unitPrice: parseInt(this.removeSeparator(obj.item_actual)),
				coaExpense:
					'DXM-DOM-' + (obj.item_costcenter || '000') + '-' + (obj.item_account || '00000') + '-' + (obj.item_subaccount || '') + '-INA-000000',
			};
		});

		return retVal;
	};

	handleReject = () => {
		if (this.state.reason.length === 0) {
			this.setState({ error: ['Reason must be filled'] });
			window.scrollTo(0, 0);
			return false;
		}
		let url = '/api/traces/v1/claim/update-principal';
		let { id } = this.props.match.params;
		let param = {
			claim_id: id,
			status: 'R',
			reason: this.state.reason,
			source: 'infostep',
			menu: 'claim',
			function: 'approval claim',
			user_id: this.state.user.user_id,
			user_name: this.state.user.username,
		};
		this.setState({ loading: true });
		request.postTraces(url, param, {
			success: function (response) {
				this.setState({ loading: false, success: 'Claim has been rejected' });
				window.scrollTo(0, 0);
				let app = this;
				window.setTimeout(() => {
					app.props.history.push('/admin/claim/approval-dxm');
				}, 2000);
			}.bind(this),
			error: function (e) {
				this.setState({ loading: false });
			}.bind(this),
		});
	};

	claimToOracle = () => {
		let url = '/api/orafin/v1/claim/approve-princ';
		let {
			principalLetterNo,
			programType,
			customerName,
			orgInitital,
			claimNumber,
			branchId,
			branchCode,
			paymentMethod,
			totalAmount,
			customerId,
			orgId,
		} = this.state;
		let invoiceArr = this.state.listInvoice.map((item, index) => {
			return item.invoice_id + '*' + parseInt(item.invoice_amount);
		});
		let param = {
			claimNo: claimNumber,
			branchId: branchId,
			branchCode: branchCode,
			payMethod: paymentMethod,
			principal: orgInitital,
			claimTotal: this.removeSeparator(totalAmount),
			custId: customerId,
			orgId: orgId,
			invoice_arr: invoiceArr,
			progType: programType,
			customerName: customerName,
			principalLetterNo: principalLetterNo,
		};

		this.setState({ loading: true });
		request.postOracle(url, param, {
			success: function (response) {
				this.handleApprove();
			}.bind(this),
			error: function (e) {
				console.log(e);
				this.setState({ loading: false });
				alert('Failed to approve claim, please try again');
			}.bind(this),
		});
	};

	onChangeAutocomplete = (q) => {
		let param = {
			supplier_name: q,
		};
		return new Promise((resolve, reject) => {
			request.postOracle('/api/orafin/v1/claim/supplier', param, {
				success: function (response) {
					let { data } = response.data;
					let lovSupplier = [];
					data.forEach((item, index) => {
						// [0] supplier name [1] supplier id
						lovSupplier.push({ text: item[0], value: item[1] });
					});
					resolve(lovSupplier);
				},
				error: function (e) {
					resolve([]);
				},
			});
		});
	};

	onSelectSupplier = (item, index) => {
		this.setState({ supplier: item.text, supplierId: item.value });
		this.getSupplierSite(item.value);
	};

	getSupplierSite = (id) => {
		if (!id || id.length === 0) {
			return false;
		}
		let url = '/api/v1/oracle/supplier-site';
		let param = { supplier_id: id };
		this.setState({ loading: true });
		request.postOracle(url, param, {
			success: function (response) {
				let { data } = response.data;
				let lovSupplierSite = [];
				data.forEach((item, index) => {
					lovSupplierSite.push({
						SUPPLIER_SITE_CODE: item[0],
						SUPPLIER_SITE_ID: item[1],
					});
				});
				this.setState({ lovSupplierSite: lovSupplierSite, loading: false });
			}.bind(this),
			error: function (e) {
				this.setState({ loading: false });
			}.bind(this),
		});
	};

	customerInfo = () => {
		// console.log(this.state.productList);
		return (
			<div className='row'>
				<div className='col-md-6'>
					<div className='form-group row'>
						<label htmlFor='inputEmail3' className='col-sm-3 col-form-label'>
							Customer
						</label>
						<div className='col-sm-9'>
							<input
								type='text'
								autoComplete='off'
								disabled
								className='form-control'
								id='inputEmail3'
								name='customerName'
								placeholder=''
								// onChange={this.handleChangeInput.bind(this)}
								value={this.state.customerName}
							/>
						</div>
					</div>

					<div className='form-group row'>
						<label htmlFor='inputEmail3' className='col-sm-3 col-form-label'>
							NPWP Name
						</label>
						<div className='col-sm-9'>
							<input
								type='text'
								disabled
								autoComplete='off'
								className='form-control'
								id='inputEmail3'
								name='header_npwp_name'
								placeholder=''
								value={this.state.header_npwp_name}
							/>
						</div>
					</div>
					<div className='form-group row'>
						<label htmlFor='inputEmail3' className='col-sm-3 col-form-label'>
							Npwp Address
						</label>
						<div className='col-sm-9'>
							<textarea
								autoComplete='off'
								disabled
								className='form-control'
								id='inputEmail3'
								name='headerNpwpAddress'
								placeholder=''
								value={this.state.header_npwp_address}
							/>
						</div>
					</div>
					<div className='form-group row'>
						<label htmlFor='inputEmail3' className='col-sm-3 col-form-label'>
							NPWP / NIK
						</label>
						<div className='col-sm-9'>
							<input
								type='text'
								autoComplete='off'
								disabled
								className='form-control'
								id='inputEmail3'
								name='header_npwp'
								placeholder=''
								onChange={this.handleChangeInput.bind(this)}
								value={this.state.header_npwp}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	};

	// renderProduct = () => {
	//   console.log(this.state.productList);
	//   return this.state.productList.map((item, index) => (
	//     <div className="row mb-2" key={index}>
	//       <div className="col-sm-4">
	//         <input
	//           disabled
	//           type="text"
	//           className="form-control"
	//           name="productname"
	//           value={item.item_description}
	//         />
	//       </div>
	//       <div className="col-sm-2">
	//         <input
	//           disabled
	//           type="text"
	//           className="form-control"
	//           name="itemReff"
	//           value={item.item_reff}
	//         />
	//       </div>
	//       <div className="col-sm-2">
	//         <input
	//           disabled
	//           type="text"
	//           className="form-control"
	//           name="itemBudget"
	//           // value={item.item_budget}
	//           // value={item.item_budget}
	//           value={item.item_budget.toLocalString("en-US", {
	//             minimumFractionDigits: 2,
	//             maximumFractionDigits: 2,
	//           })}
	//         />
	//       </div>
	//       <div className="col-sm-2">
	//         <input
	//           type="text"
	//           disabled
	//           className="form-control"
	//           name="itemActual"
	//           currentIndex={index}
	//           // value={item.item_actual}
	//           // value={item.item_actual}
	//           value={item.item_actual.toLocaleString("en-US", {
	//             minimumFractionDigits: 2,
	//             maximumFractionDigits: 2,
	//           })}
	//         />
	//       </div>
	//     </div>
	//   ));
	// };

	handleChangeReason = (value) => {
		this.setState({ reason: value });
	};

	AccountInfo = () => {
		return (
			<div className='card'>
				<div className='card-header bg-light font-weight-bold'>
					Account Info
				</div>
				<div className='multi-collapse show' id='multiCollapseExample1'>
					<div className='card-body'>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-group row'>
									<label
										htmlFor='inputEmail3'
										className='col-sm-3 col-form-label'>
										Cost Center
									</label>
									<div className='col-sm-8'>
										<input
											type='text'
											autoComplete='off'
											className='form-control'
											maxLength="3"
											onChange={(e) =>
												this.setState({ costCenter: e.target.value })
											}
											name='costCenter'
											placeholder=''
											value={this.state.costCenter}
										/>
									</div>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-group row'>
									<label
										htmlFor='inputEmail3'
										className='col-sm-3 col-form-label'>
										Account
									</label>
									<div className='col-sm-8'>
										<input
											type='text'
											autoComplete='off'
											className='form-control'
											onChange={(e) =>
												this.setState({ account: e.target.value })
											}
											name='totalAmount'
											placeholder=''
											value={this.state.account}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	ProductInfo = () => {
		let app = this
		let { lovCC } = app.state
		return (
			<div className='card'>
				<div className='card-header bg-light font-weight-bold'>
					Products
				</div>
				<div className='multi-collapse show' id='multiCollapseExample1'>
					<div className='card-body'>
						<div className="row">
							<table className="table table-responsive">
								<thead className="bg-secondary">
									<tr>
										<th className="text-center">Description</th>
										<th className="text-center">Reff</th>
										<th className="text-center">Budget</th>
										<th className="text-center">Actual</th>
										<th className="text-center">Cost Center</th>
										<th className="text-center">Account</th>
										<th className="text-center">Sub Account</th>
									</tr>
								</thead>
								<tbody>
									{
										this.state.productList.map((item, index) => (
											<tr>
												<td>{item.item_description}</td>
												<td>{item.item_reff}</td>
												<td>{item.item_budget ? app.numberFormat(item.item_budget) : ''}</td>
												<td>{item.item_actual}</td>
												<td>
													<Autocomplete
														onchange={this.onChangeAutocompleteCC.bind(this, index)}
														currentIndex={index}
														onselect={this.onSelectCC.bind(this)}
														startapi={1}
													/>
												</td>
												<td>
													<Autocomplete
														onchange={this.onChangeAutocompleteACC.bind(this, index)}
														currentIndex={index}
														onselect={this.onSelectACC.bind(this)}
														startapi={2}
													/>
												</td>
												<td>
													<Autocomplete
														onchange={this.onChangeAutocompleteSUBACC.bind(this, index)}
														currentIndex={index}
														onselect={this.onSelectSUBACC.bind(this)}
														startapi={3}
													/>
												</td>
											</tr>
										))
									}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		)
	}

	onSelectCC = (item, index) => {
		let { productList } = this.state
		productList[index]['item_costcenter'] = item.value
		this.setState(productList)

		let app = this
		window.setTimeout(() => {
			console.log(app.state.productList)
		}, 200)
	}

	onSelectACC = (item, index) => {
		let { productList } = this.state
		productList[index]['item_account'] = item.value
		this.setState(productList)
	}

	onSelectSUBACC = (item, index) => {
		let { productList } = this.state
		productList[index]['item_subaccount'] = item.value
		this.setState(productList)
	}

	onChangeAutocompleteCC = (index, description) => {
		let container = [];
		return new Promise((resolve) => {
			let url = '/finance/comet-AP/v1/get-cost-center-dxg?query=' + description
			request.getFinance(url, {}, {
				success: function (response) {
					let { data } = response.data
					container = data.map((item) => {
						item.text = item.label;
						item.value = item.value;
						return item;
					});
					resolve(container);
				}.bind(this),
				error: (e) => {
					console.log(e.message)
				}
			})
		});
	}

	onChangeAutocompleteACC = (index, description) => {
		let container = [];
		return new Promise((resolve) => {
			let url = '/finance/comet-AP/v1/get-account-dxg?query=' + description
			request.getFinance(url, {}, {
				success: function (response) {
					let { data } = response.data
					container = data.map((item, index) => {
						item.text = item.label;
						item.value = item.value;
						return item;
					});
					resolve(container);
				}.bind(this),
				error: (e) => {
					console.log(e.message)
				}
			})
		});
	}

	onChangeAutocompleteSUBACC = (index, description) => {
		let container = [];
		return new Promise((resolve) => {
			let url = '/finance/comet-AP/v1/get-subaccount-dxg?query=' + description
			request.getFinance(url, {}, {
				success: function (response) {
					let { data } = response.data
					container = data.map((item, index) => {
						item.text = item.label;
						item.value = item.value;
						return item;
					});
					resolve(container);
				}.bind(this),
				error: (e) => {
					console.log(e.message)
				}
			})
		});
	}

	handleAccount = (name, index, e) => {
		let value = e.target.value
		let { productList } = this.state

		productList[index][name] = value
		this.setState(productList)
	}

	numberFormat = (value) => {
		return value ? value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, }) : ''
	}

	render() {
		return (
			<div>
				<section className='content'>
					<div className='container-fluid'>
						<div className='row ml-1'>
							<div className='col-lg-12 col-sx-12'>
								<div className='card card-info'>
									<div className='card-body'>
										{this.showError()}
										{this.showSuccess()}
										<form className='form-horizontal'>
											<GeneralInfo data={this.state} />
											<CustomerInfo data={this.state} />
											{/* <ProductList data={this.state} /> */}
											{this.ProductInfo()}
											<Attachments data={this.state} />
											<ClaimInfo data={this.state} />
											{/* {this.AccountInfo()} */}
											<Reason
												data={this.state}
												onChange={this.handleChangeReason.bind(this)}
											/>
											<div className='clearfix'>&nbsp;</div>
											<div className='row'>
												<div className='col-md-6'>
													<button
														type='button'
														className='btn btn-success'
														// onClick={this.claimToOracle.bind(this)}>
														onClick={this.handleFinance.bind(this)}>
														<i className='fas fa-check' /> Approve
													</button>
													&nbsp;
													<button
														type='button'
														className='btn btn-danger'
														onClick={this.handleReject.bind(this)}>
														<i className='fas fa-check' /> Reject
													</button>
													&nbsp;
													<button
														type='button'
														className='btn btn-warning'
														onClick={() => {
															this.props.history.push(
																'/admin/claim/approval-dxm'
															);
														}}>
														<i className='fas fa-arrow-left'></i> Back
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<Loader fullPage loading={this.state.loading} />
			</div>
		);
	}
}

export default Detail;
